

export function clearMask(bicWithMask: string): string {
  const bicWithoutMAsk = bicWithMask.replace('_', '')
  return bicWithoutMAsk
}
